module.exports = __webpack_public_path__ + "static/img/15.91a89c46.png";